import React from "react";

function OSSErrorMessage({ error }) {
  function formatError(err) {
    if (typeof err === "string")
      return (
        <>
          {err}
          <br />
        </>
      );

    if (Array.isArray(err)) {
      return err.map(e => formatError(e));
    }

    if (typeof err === "object") {
      return Object.keys(err).map(key => (
        <React.Fragment key={key}>
          {key}
          <br />
          {formatError(err[key])}
        </React.Fragment>
      ));
    }
  }

  return <p>{formatError(error)}</p>;
}

export default OSSErrorMessage;
